export default "__VITE_ASSET__CE_wY63Y__"